<div *samwebVar="areEditableEntriesChanged$ | async; let areEditableEntriesChanged">
   <samweb-window
      [id]="id"
      [type]="type"
      [titleBarIcon]="icon"
      [titleBarHeader]="title | translate"
      [titleBarAdditionalInfo]="(directoryEditInfo$ | async).editedEntry.orgnam"
      (cancel)="onCancel(areEditableEntriesChanged)"
      kendoTooltip
      showOn="none"
      #closeTooltipDirective="kendoTooltip"
      [tooltipTemplate]="closeDialog"
      tooltipClass="tooltip-confirm-dialog"
   >
      <ng-container>
         <samweb-directory-editing-content
            [id]="id"
            [directoryEditInfo$]="directoryEditInfo$"
            [areEditableEntriesChanged]="areEditableEntriesChanged"
         >
         </samweb-directory-editing-content>
      </ng-container>
      <ng-template #closeDialog>
         <div (samwebOutsideClick)="onCloseCancel()">
            <samweb-confirm-dialog
               [displayedText]="'common.confirmation.close_entry' | translate"
               (confirm)="onCloseConfirm()"
               (cancel)="onCloseCancel()"
            ></samweb-confirm-dialog>
         </div>
      </ng-template>
   </samweb-window>
</div>
